import type { AuthFlowState, GuestSession } from '@/types/GuestSession'

const GUEST_SESSION_KEY = 'guest_session_v1'
const AUTH_FLOW_STATE_KEY = 'auth_flow_state'

/**
 * Loads guest session from localStorage
 */
export function loadGuestSession(): GuestSession | null {
  try {
    const stored = localStorage.getItem(GUEST_SESSION_KEY)
    if (!stored) {
      return null
    }
    return JSON.parse(stored) as GuestSession
  } catch (error) {
    console.error('Failed to load guest session:', error)
    return null
  }
}

/**
 * Saves guest session to localStorage
 */
export function saveGuestSession(session: GuestSession): void {
  try {
    localStorage.setItem(GUEST_SESSION_KEY, JSON.stringify(session))
  } catch (error) {
    console.error('Failed to save guest session:', error)
  }
}

/**
 * Clears guest session from localStorage
 */
export function clearGuestSession(): void {
  try {
    localStorage.removeItem(GUEST_SESSION_KEY)
  } catch (error) {
    console.error('Failed to clear guest session:', error)
  }
}

/**
 * Loads auth flow state from localStorage
 */
export function loadAuthFlowState(): AuthFlowState | null {
  try {
    const stored = localStorage.getItem(AUTH_FLOW_STATE_KEY)
    if (!stored) {
      return null
    }
    return JSON.parse(stored) as AuthFlowState
  } catch (error) {
    console.error('Failed to load auth flow state:', error)
    return null
  }
}

/**
 * Saves auth flow state to localStorage
 */
export function saveAuthFlowState(state: AuthFlowState): void {
  try {
    localStorage.setItem(AUTH_FLOW_STATE_KEY, JSON.stringify(state))
  } catch (error) {
    console.error('Failed to save auth flow state:', error)
  }
}

/**
 * Clears auth flow state from localStorage
 */
export function clearAuthFlowState(): void {
  try {
    localStorage.removeItem(AUTH_FLOW_STATE_KEY)
  } catch (error) {
    console.error('Failed to clear auth flow state:', error)
  }
}
